var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_360)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.0848,
    cy: 21.477,
    rx: 14.7816,
    ry: 18.477,
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.947,
    cy: 20.4533,
    rx: 15.4344,
    ry: 12.9141,
    transform: "rotate(-20.2224 19.947 20.4533)",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2813,
    cy: 28.4982,
    rx: 15.1512,
    ry: 15.8902,
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.4112,
    cy: 25.9116,
    rx: 15.1512,
    ry: 18.477,
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.918,
    cy: 24.0666,
    rx: 16.9989,
    ry: 15.8825,
    transform: "rotate(-9.48556 31.918 24.0666)",
    fill: "white",
    fillOpacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.6072,
    cy: 23.6938,
    r: 18.1075,
    fill: "#FFBA4D",
    stroke: "white",
    strokeWidth: 0.739081
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1161_360)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1161_360)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4555 22.5739C34.6266 22.7063 34.7651 22.8761 34.8604 23.0703C34.9556 23.2645 35.0052 23.478 35.0052 23.6943C35.0052 23.9106 34.9556 24.1241 34.8604 24.3183C34.7651 24.5125 34.6266 24.6823 34.4555 24.8147C32.2401 26.5289 29.7664 27.8801 27.1268 28.8176L26.6442 28.9891C25.7218 29.3165 24.7477 28.6927 24.6228 27.74C24.2739 25.0542 24.2739 22.3344 24.6228 19.6486C24.7477 18.6959 25.7218 18.0721 26.6442 18.3995L27.1268 18.571C29.7664 19.5085 32.2401 20.8597 34.4555 22.5739ZM33.777 23.9382C33.8143 23.9094 33.8445 23.8724 33.8653 23.8302C33.886 23.7879 33.8968 23.7414 33.8968 23.6943C33.8968 23.6472 33.886 23.6007 33.8653 23.5584C33.8445 23.5162 33.8143 23.4792 33.777 23.4504C31.6546 21.8081 29.2846 20.5135 26.7558 19.6153L26.2731 19.4438C26.2139 19.4244 26.1511 19.4183 26.0892 19.426C26.0273 19.4336 25.9679 19.4549 25.9152 19.4882C25.8625 19.5216 25.8178 19.5662 25.7844 19.6188C25.751 19.6714 25.7296 19.7308 25.7218 19.7927C25.3854 22.3829 25.3854 25.0057 25.7218 27.5959C25.7297 27.6577 25.7511 27.717 25.7846 27.7696C25.8181 27.8221 25.8628 27.8666 25.9155 27.8999C25.9681 27.9331 26.0275 27.9543 26.0894 27.962C26.1512 27.9696 26.214 27.9635 26.2731 27.944L26.7558 27.7733C29.2847 26.8748 31.6547 25.5808 33.777 23.9382Z",
    fill: "#553D81"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.4064 22.9603C34.0513 23.3326 34.0513 24.2634 33.4064 24.6358L26.8768 28.4056C26.2319 28.778 25.4258 28.3126 25.4258 27.5679L25.4258 20.0282C25.4258 19.2835 26.2319 18.8181 26.8768 19.1904L33.4064 22.9603Z",
    fill: "#553D81"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_360",
    x: 0.918201,
    y: 0.0979525,
    width: 51.8411,
    height: 49.1275,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.967349
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9347
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1161_360",
    x: 19.987,
    y: 15.0309,
    width: 19.3922,
    height: 19.5138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.09353
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18705
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.348852 0 0 0 0 0.286155 0 0 0 0 0.447222 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_360"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1161_360",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7379,
    height: 17.7379,
    fill: "white",
    transform: "translate(20.2166 14.8252)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnImage);
export default __webpack_public_path__ + "static/media/btn_image.a1691599e0e0508666135c51498057a8.svg";
export { ForwardRef as ReactComponent };